// Mutaion is used to modify server-side-data
import request, { gql } from "graphql-request";

export const createLeadProspect = gql`
 mutation CreateLeadProspect($input: LeadProspectInput!) {
    createLeadProspect(input: $input) {
      success
      message
    }
  }
`; //leadandprospect mutation addvalue
export const REQUEST_PASSWORD_URL = gql`
  mutation ForgotPassword($email: String!) {
    forgotPassword(email: $email) {
      success
      message
      error
    }
  }
 
`;

  export const ctcmutation = gql`
  mutation ctc($ctc:Float!){
  calculateCtc(ctc:$ctc){
    monthlyCtc
    dailyCtc
    hourlyCtc
  }
}
  
  
  `

  export const createpricing =gql`
  
  mutation createpricing($input:CreatePricingInput!){
  createPricing(input:$input){
    success
    message
  }
}
  
  
  `

  export const updatepricing = gql`
  
  mutation updatepricing($input:UpdatePricingInput!){
  updatePricing(input:$input){
    success
    message
  }
}
  
  `

  export const createprojectestimation = gql`
  
  mutation createprojectestimate($input:CreateProjectEstimateInput!){
  createProjectEstimate(input:$input){
    success
    message
  }
}
  
  
  `

  export const deleteprojectestimate = gql `
  
   mutation deleteprojectdetails($id:ID!){
  deleteProjectEstimateDetails(id:$id){
    success
    message
  }
}
  
  
  `

  export const updateprojectestimation =gql`
  
    mutation updateprojectestimate($input:UpdateProjectEstimateInput!){
  updateProjectEstimate(input:$input){
    success
    message
  }
}
  
  `
export const updateLeadProspect = gql`
mutation UpdateLeadProspect($input: UpdateLeadProspectInput!) {
    updateLeadProspect(input: $input) {
      success
      message
      }
    }
`; //leadandprospect mutation updatevalue

export const deleteLeadAndProspect = gql`
  mutation DeleteLeadProspect($id: String!) {
    deleteLeadProspect(id: $id) {
      set
    }
  }
`; //leadandprospect mutation updatevalue deltevalue by id

export const LOGIN = gql`
  mutation Login($email: String!, $password: String!) {
    tokenAuth(email: $email, password: $password) {
      success
      errors
      token
      refreshToken
      user {
        id
        email
        username
        firstName
        lastName
        isActive
        role
      }
    }
  }
`;

export const AddCutomerMutation = gql`
 mutation input(
    $id: String!
    $GSTNumber: String!
    $legalName: String!
    $tradeName: String!
    $customerCategory: String!
    $pan: String!
    $taxPayerType: String!
    $dateOfRegistration: String!
    $mail: String!
    $address1Line1: String!
    $address1Line2: String!
    $country1: String!
    $state1: String!
    $city1: String!
    $zipCode1: String!
    $address2Line1: String!
    $address2Line2: String!
    $state2: String!
    $city2: String!
    $country2: String!
    $zipCode2: String!
  ) {
    createCustomer(
      input: {
        id: $id
        GSTNumber: $GSTNumber
        legalName: $legalName
        tradeName: $tradeName
        customerCategory: $customerCategory
        pan: $pan
        taxPayerType: $taxPayerType
        dateOfRegistration: $dateOfRegistration
        mail: $mail
        address1Line1: $address1Line1
        address1Line2: $address1Line2
        country1: $country1
        state1: $state1
        city1: $city1
        zipCode1: $zipCode1
        address2Line1: $address2Line1
        address2Line2: $address2Line2
        state2: $state2
        city2: $city2
        country2: $country2
        zipCode2: $zipCode2
      }
    ) {
      success
      message
    }
  }
`;

export const updateCustomerMutation = gql`
 mutation input(
    $id: String!
    $GSTNumber: String!
    $legalName: String!
    $tradeName: String!
    $customerCategory: String!
    $pan: String!
    $taxPayerType: String!
    $dateOfRegistration: String!
    $mail: String!
    $address1Line1: String!
    $address1Line2: String!
    $country1: String!
    $state1: String!
    $city1: String!
    $zipCode1: String!
    $address2Line1: String!
    $address2Line2: String!
    $state2: String!
    $city2: String!
    $country2: String!
    $zipCode2: String!
  ) {
    editCustomer(
      input: {
        id: $id
        GSTNumber: $GSTNumber
        legalName: $legalName
        tradeName: $tradeName
        customerCategory: $customerCategory
        pan: $pan
        taxPayerType: $taxPayerType
        dateOfRegistration: $dateOfRegistration
        mail: $mail
        address1Line1: $address1Line1
        address1Line2: $address1Line2
        country1: $country1
        state1: $state1
        city1: $city1
        zipCode1: $zipCode1
        address2Line1: $address2Line1
        address2Line2: $address2Line2
        state2: $state2
        city2: $city2
        country2: $country2
        zipCode2: $zipCode2
      }
    ) {
      success
      message
    }
  }
`;

export const DeleteCustomerMutation = gql`
  mutation deleteCustome($id: String!) {
    deleteCustomer(id: $id) {
      set
    }
  }
`;

export const AddVendorMutation = gql`
  mutation mutation(
    $id: String!
    $GSTNumber: String!
    $legalName: String!
    $tradeName: String!
    $vendorCategory: String!
    $pan: String!
    $taxPayerType: String!
    $dateOfRegistration: String!
    $mail: String!
    $address1Line1: String!
    $address1Line2: String!
    $country1: String!
    $state1: String!
    $state2: String!
    $city1: String!
    $city2: String!
    $zipCode1: String!
    $address2Line1: String!
    $address2Line2: String!
    $country2: String!
    $zipCode2: String!
  ) {
    createVendor(
      input: {
        id: $id
        GSTNumber: $GSTNumber
        legalName: $legalName
        tradeName: $tradeName
        vendorCategory: $vendorCategory
        pan: $pan
        taxPayerType: $taxPayerType
        dateOfRegistration: $dateOfRegistration
        mail: $mail
        address1Line1: $address1Line1
        address1Line2: $address1Line2
        country1: $country1
        state1: $state1
        zipCode1: $zipCode1
        address2Line1: $address2Line1
        address2Line2: $address2Line2
        country2: $country2
        city1: $city1
        city2: $city2
        state2: $state2
        zipCode2: $zipCode2
      }
    ) {
      Vendor {
        id
      }
    }
  }
`;

export const DeleteVendorMutation = gql`
  mutation deleteVendor($id: String!) {
    deleteVendor(id: $id) {
      set
    }
  }
`;

// export const AddRoleMutation = gql`
//   mutation createRoleDetail($role: String!) {
//     createRoleDetail(role: $role) {
//       RoleDetail {
//         id
//         role
//         status
//       }
//     }
//   }
// `;

export const AddRoleMutation = gql`
  mutation createRole($user: String!, $role: String!) {
    createRoleDetail(user: $user, role: $role) {
      RoleDetail {
        id
        role
      }
    }
  }
`;

export const DeleteRoleMutation = gql`
  mutation deleteRoleDetail($id: String!) {
    deleteRoleDetail(id: $id) {
      set
    }
  }
`;

export const AddEmployeeMutation = gql`
  mutation createUser(
    $username: String!
    $email: String!
    $masterId: String!
    $role: String!
    $contactno: String!
  ) {
    createUser(
      input: {
        username: $username
        email: $email
        masterId: $masterId
        role: $role
        contactno: $contactno
      }
    ) {
      users {
        id
        email
        username
        masterId
        role
      }
    }
  }
`;
export const createbrand = gql`
  mutation createbrand($input: CreateBranddetailsInput!) {
    createBrandDetail(input: $input) {
      set
    }
  }
`;

export const setPasswordEmployee = gql`
  mutation resetPassword($email: String!) {
    sendPasswordResetEmail(email: $email) {
      errors
      success
    }
  }
`;

export const DeleteEmployeeMutation = gql`
  mutation deleteUser($id: String!) {
    deleteUser(id: $id) {
      set
    }
  }
`;

export const AddContactMutation = gql`
 mutation createContact(
    $id: String!
    $firstName: String!
    $lastName: String!
    $organizationId: String!
    $organizationType: String!
    $organizationName: String!
    $landLineNumber: String!
    $role: String
    $whatsappNumber: String!
    $dateOfBirth: String!
    $age: String!
    $contactNumber: String!
    $secondaryNumber: String!
    $mail: String!
    $address1Line1: String!
    $address1Line2: String!
    $country1: String!
    $state1: String!
    $city1: String!
    $zipCode1: String!
  ) {
    createContact(
      input: {
        id: $id
        firstName: $firstName
        lastName: $lastName
        landLineNumber: $landLineNumber
        organizationId: $organizationId
        organizationType: $organizationType
        organizationName: $organizationName
        contactNumber: $contactNumber
        secondaryNumber: $secondaryNumber
        whatsappNumber: $whatsappNumber
        role: $role
        dateOfBirth: $dateOfBirth
        age: $age
        mailId: $mail
        address1Line1: $address1Line1
        address1Line2: $address1Line2
        country1: $country1
        state1: $state1
        city1: $city1
        zipCode1: $zipCode1
      }
    ) {
     success
      message
    }
  }
`;

export const DeleteContactMutation = gql`
  mutation deleteContact($id: String!) {
    deleteContact(id: $id) {
      set
    }
  }
`;

// appointment mutation

export const createAppointmentMutation = gql`
  mutation CreateAppointment($input: AppointmentInput!) {
    createAppointment(input: $input) {
      success
      message
    }
  }
`;

export const updateAppointmentMutation = gql`
 mutation updateAppointment($input: UpdateAppointmentInput) {
    updateAppointment(input: $input) {
      success
      message
    }
  }
`;

export const deleteAppointmentMutation = gql`
  mutation deleteAppointment($id: String!) {
    deleteAppointment(id: $id) {
      set
    }
  }
`;

export const AddUomMutation = gql`
 mutation createUom(
    $user: String!
    $uomName: String!
    $uomAbbreviation: String!
    $decimalPlaces: String!
    $baseUnitValue: Int!
    $baseUnit: String!
    $status: Boolean!
  ) {
    createUom(
      input: {
        user: $user
        uomName: $uomName
        uomAbbreviation: $uomAbbreviation
        decimalPlaces: $decimalPlaces
        baseUnitValue: $baseUnitValue
        baseUnit: $baseUnit
        status: $status
      }
    ) {
      set
      message
    }
  }
`;

export const DeleteUomMutation = gql`
  mutation deleteUom($id: String!) {
    deleteUom(id: $id) {
      set
    }
  }
`;

export const DeleteBrandMutation = gql`
  mutation deleteBrand($id: String!) {
    deleteBrand(id: $id) {
      set
    }
  }
`;

export const AddCategoryMutation = gql`
  mutation createProductcategory($user: String!, $categoryName: String!) {
    createProductcategory(user: $user, categoryName: $categoryName) {
      success
      message
      }
    }
`;

export const DeleteCategoryMutation = gql`
  mutation deleteCategory($id: String!) {
    deleteProductcategory(id: $id) {
      set
    }
  }
`;

export const deleteProduct = gql`
  mutation deleteproduct($id: String!) {
    deleteProduct(id: $id) {
      set
    }
  }
`;

export const createProduct = gql`
  mutation productinput($input: ProductInput!) {
    createProduct(input: $input) {
      set
    }
  }
`;

export const DeleteWareHouseMutation = gql`
  mutation deleteWarehouse($id: String!) {
    deleteWarehouse(id: $id) {
      set
    }
  }
`;

export const AddOpportunityTypeMutation = gql`
mutation createOpportunitytype(
    $user: String!
    $typeName: String!
    $description: String!
  ) {
    createOpportunitytype(
      user: $user
      typeName: $typeName
      description: $description
    ) {
      set
      message
    }
  }
`;

export const DeleteOpportunityTypeMutation = gql`
  mutation deleteOpportunitytype($id: String!) {
    deleteOpportunitytype(id: $id) {
      set
    }
  }
`;

export const AddOpportunityMutation = gql`
 mutation createOpportunity(
    $user: String!
    $opportunityType: String!
    $opportunityFrom: String!
    $Source: String!
    $customerOrLeadName: String!
    $contact: String!
    $stage: String!
    $opportunityOwner: String!
    $winProbability: Int!
    $status: String!
    $opportunityAmount: Int!
    $expectedClosingDate: String!
  ) {
    createOpportunity(
      user: $user
      opportunityType: $opportunityType
      opportunityFrom: $opportunityFrom
      Source: $Source
      contact: $contact
      stage: $stage
      customerOrLeadName: $customerOrLeadName
      opportunityOwner: $opportunityOwner
      winProbability: $winProbability
      status: $status
      opportunityAmount: $opportunityAmount
      expectedClosingDate: $expectedClosingDate
    ) {
      success
      message
    }
  }
`;

export const DeleteOpportunityMutation = gql`
  mutation deleteOpportunity($id: String!) {
    deleteOpportunity(id: $id) {
      set
    }
  }
`;

export const AddSaleStageMutation = gql`
mutation createSalesstage(
    $user: String!
    $stageName: String!
    $description: String!
  ) {
    createSalesstage(
      user: $user
      stageName: $stageName
      description: $description
    ) {
      set
      message
    }
  }
`;

export const DeleteSalesStageMutation = gql`
  mutation deleteSalesstage($id: String!) {
    deleteSalesstage(id: $id) {
      set
    }
  }
`;

export const deleteQuotation = gql`
  mutation deteteQuotation($id: String!) {
    deleteQuotation(id: $id) {
      set
    }
  }
`;

export const CreateQuotation = gql`
  mutation createQuotation(
    $user: String!
    $opportunity: String!
    $customer: String!
    $billingAddress: String!
    $shippingAddress: String!
    $contactPerson: String!
    $quoteDate: String!
    $dueDate: String!
    $accountingManager: String!
    $termsAndConditions: String!
    $additionalInformations: String!
    $subTotal: Int!
    $totalTaxAmount: Int!
    $amountAndTax: Int!
    $otherCharges: Int!
    $otherChargesDescription: String!
    $discount: Int!
    $discountPercentage: Int!
    $totalAmount: Int!
    $features:String!
  ) {
    createQuotation(
      input: {
        user: $user
        opportunity: $opportunity
        customer: $customer
        billingAddress: $billingAddress
        shippingAddress: $shippingAddress
        contactPerson: $contactPerson
        quoteDate: $quoteDate
        dueDate: $dueDate
        accountingManager: $accountingManager
        termsAndConditions: $termsAndConditions
        additionalInformations: $additionalInformations
        subTotal: $subTotal
        totalTaxAmount: $totalTaxAmount
        amountAndTax: $amountAndTax
        otherCharges: $otherCharges
        otherChargesDescription: $otherChargesDescription
        discount: $discount
        discountPercentage: $discountPercentage
        totalAmount: $totalAmount
        features:$features
      }
    ) {
      quotation {
        id
      }
    }
  }
`;

export const CreateQuotationProduct = gql`
  mutation createQuotationProduct($input: QuotationProductsInput!) {
    createQuotationproducts(input: $input) {
      quotationProduct {
        id
      }
    }
  }
`;

export const updateOpportunitytype = gql`
mutation updateOpportunitytype(
    $id: String!
    $typeName: String!
    $description: String!
  ) {
    updateOpportunitytype(
      id: $id
      typeName: $typeName
      description: $description
    ) {
      set
      message
    }
  }
`;
export const deleteOpportunitytype = gql`
  mutation deleteOpportunitytype($id: String!) {
    deleteOpportunitytype(id: $id) {
      set
    }
  }
`;

export const deleteProductcategory = gql`
  mutation deleteCategory($id: String!) {
    deleteProductcategory(id: $id) {
      set
    }
  }
`;

export const updateProductcategory = gql`
mutation updateProductcategory($id: String!, $categoryName: String!) {
    updateProductcategory(id: $id, categoryName: $categoryName) {
      set
      message
    }
  }
`;

export const updateSalesstage = gql`
  mutation updateSalesstage(
    $id: String!
    $stageName: String!
    $description: String!
  ) {
    updateSalesstage(
      id: $id
      stageName: $stageName
      description: $description
    ) {
      set
      message
    }
  }
`;
export const deleteSalesstage = gql`
  mutation deleteSalesstage($id: String!) {
    deleteSalesstage(id: $id) {
      set
    }
  }
`;

export const editCustomer = gql`
  mutation input(
    $id: String!
    $GSTNumber: String!
    $legalName: String!
    $tradeName: String!
    $customerCategory: String!
    $pan: String!
    $taxPayerType: String!
    $dateOfRegistration: String!
    $mail: String!
    $address1Line1: String!
    $address1Line2: String!
    $country1: String!
    $state1: String!
    $city1: String!
    $zipCode1: String!
    $address2Line1: String!
    $address2Line2: String!
    $state2: String!
    $city2: String!
    $country2: String!
    $zipCode2: String!
  ) {
    editCustomer(
      input: {
        id: $id
        GSTNumber: $GSTNumber
        legalName: $legalName
        tradeName: $tradeName
        customerCategory: $customerCategory
        pan: $pan
        taxPayerType: $taxPayerType
        dateOfRegistration: $dateOfRegistration
        mail: $mail
        address1Line1: $address1Line1
        address1Line2: $address1Line2
        country1: $country1
        state1: $state1
        city1: $city1
        zipCode1: $zipCode1
        address2Line1: $address2Line1
        address2Line2: $address2Line2
        state2: $state2
        city2: $city2
        country2: $country2
        zipCode2: $zipCode2
      }
    ) {
      Customer {
        id
      }
    }
  }
`;

export const editVendor = gql`
  mutation mutation(
    $id: String!
    $GSTNumber: String!
    $legalName: String!
    $tradeName: String!
    $vendorCategory: String!
    $pan: String!
    $taxPayerType: String!
    $dateOfRegistration: String!
    $mail: String!
    $address1Line1: String!
    $address1Line2: String!
    $country1: String!
    $state1: String!
    $state2: String!
    $city1: String!
    $city2: String!
    $zipCode1: String!
    $address2Line1: String!
    $address2Line2: String!
    $country2: String!
    $zipCode2: String!
  ) {
    editVendor(
      input: {
        id: $id
        GSTNumber: $GSTNumber
        legalName: $legalName
        tradeName: $tradeName
        vendorCategory: $vendorCategory
        pan: $pan
        taxPayerType: $taxPayerType
        dateOfRegistration: $dateOfRegistration
        mail: $mail
        address1Line1: $address1Line1
        address1Line2: $address1Line2
        country1: $country1
        state1: $state1
        zipCode1: $zipCode1
        address2Line1: $address2Line1
        address2Line2: $address2Line2
        country2: $country2
        city1: $city1
        city2: $city2
        state2: $state2
        zipCode2: $zipCode2
      }
    ) {
      Vendor {
        id
      }
    }
  }
`;

export const deleteVendor = gql`
  mutation deleteVendor($id: String!) {
    deleteVendor(id: $id) {
      set
    }
  }
`;

export const createVendor = gql`
  mutation mutation(
    $id: String!
    $GSTNumber: String!
    $legalName: String!
    $tradeName: String!
    $vendorCategory: String!
    $pan: String!
    $taxPayerType: String!
    $dateOfRegistration: String!
    $mail: String!
    $address1Line1: String!
    $address1Line2: String!
    $country1: String!
    $state1: String!
    $state2: String!
    $city1: String!
    $city2: String!
    $zipCode1: String!
    $address2Line1: String!
    $address2Line2: String!
    $country2: String!
    $zipCode2: String!
  ) {
    createVendor(
      input: {
        id: $id
        GSTNumber: $GSTNumber
        legalName: $legalName
        tradeName: $tradeName
        vendorCategory: $vendorCategory
        pan: $pan
        taxPayerType: $taxPayerType
        dateOfRegistration: $dateOfRegistration
        mail: $mail
        address1Line1: $address1Line1
        address1Line2: $address1Line2
        country1: $country1
        state1: $state1
        zipCode1: $zipCode1
        address2Line1: $address2Line1
        address2Line2: $address2Line2
        country2: $country2
        city1: $city1
        city2: $city2
        state2: $state2
        zipCode2: $zipCode2
      }
    ) {
      Vendor {
        id
      }
    }
  }
`;
export const updateUom = gql`
mutation updateUom(
    $id: String!
    $uomName: String!
    $uomAbbreviation: String!
    $decimalPlaces: String!
    $baseUnitValue: Int!
    $baseUnit: String!
  ) {
    updateUom(
      input: {
        id: $id
        uomName: $uomName
        uomAbbreviation: $uomAbbreviation
        decimalPlaces: $decimalPlaces
        baseUnitValue: $baseUnitValue
        baseUnit: $baseUnit
      }
    ) {
     set
      message
    }
  }
`;

export const deleteUom = gql`
  mutation deleteUom($id: String!) {
    deleteUom(id: $id) {
      set
    }
  }
`;

export const updateOpportunity = gql`
  mutation updateOpportunity(
    $id: String!
    $opportunityType: String!
    $opportunityFrom: String!
    $contact: String!
    $Source: String!
    $salesStage: String!
    $status: String!
    $stage: String!
    $winProbability: Int!
    $customerOrLeadName: String!
    $expectedClosingDate: String!
    $opportunityOwner: String!
    $opportunityAmount: Int!
  ) {
    updateOpportunity(
      id: $id
      opportunityType: $opportunityType
      opportunityFrom: $opportunityFrom
      opportunityOwner: $opportunityOwner
      customerOrLeadName: $customerOrLeadName
      contact: $contact
      Source: $Source
      stage: $stage
      salesStage: $salesStage
      status: $status
      winProbability: $winProbability
      expectedClosingDate: $expectedClosingDate
      opportunityAmount: $opportunityAmount
    ) {
      set
      message
    }
  }
`;

export const deleteOpportunity = gql`
  mutation deleteOpportunity($id: String!) {
    deleteOpportunity(id: $id) {
      set
    }
  }
`;

export const deleteRoleDetail = gql`
  mutation deleteRoleDetail($id: String!) {
    deleteRoleDetail(id: $id) {
      set
    }
  }
`;

export const updateContact = gql`
mutation updateContact($input: UpdateContactInput) {
    updateContact(input: $input) {
      success
    message
    }
  }
`;

export const deleteContact = gql`
  mutation deleteContact($id: String!) {
    deleteContact(id: $id) {
      set
    }
  }
`;

export const updateUser = gql`
  mutation updateUser($input: UpdateUsersDetailsInput!) {
    updateUser(input: $input) {
      users {
        id
        username
        email
        role
        contactno
      }
    }
  }
`;

export const deleteUser = gql`
  mutation deleteUser($id: String!) {
    deleteUser(id: $id) {
      set
    }
  }
`;
export const createQuotation = gql`
    mutation createQuotation(
    $user: String!
    $opportunity: String!
    $customer: String!
    $businessPartner: String!
    $billingAddress: String!
    $shippingAddress: String!
    $contactPerson: String!
    $quoteDate: String!
    $dueDate: String!
    $preferredBy:String!
    $accountingManager: String!
    $termsAndConditions: String!
    $additionalInformations: String!
    $subTotal: Int!
    $totalTaxAmount: Int!
    $amountAndTax: Int!
    $otherCharges: Int!
    $otherChargesDescription: String!
    $discount: Int!
    $discountPercentage: Int!
    $totalAmount: Int!
    $features:String!
  ) {
    createQuotation(
      input: {
        user: $user
        opportunity: $opportunity
        customer: $customer
        businessPartner: $businessPartner
        billingAddress: $billingAddress
        shippingAddress: $shippingAddress
        contactPerson: $contactPerson
        quoteDate: $quoteDate
        dueDate: $dueDate
        preferredBy:$preferredBy
        accountingManager: $accountingManager
        termsAndConditions: $termsAndConditions
        additionalInformations: $additionalInformations
        subTotal: $subTotal
        totalTaxAmount: $totalTaxAmount
        amountAndTax: $amountAndTax
        otherCharges: $otherCharges
        otherChargesDescription: $otherChargesDescription
        discount: $discount
        discountPercentage: $discountPercentage
        totalAmount: $totalAmount
        features:$features
      }
    ) {
      success
      message
      data{
        id
      }
    }
  }
`;


export const createQuotationProduct = gql`
mutation createQuotationProduct($input: QuotationProductsInput!) {
    createQuotationproducts(input: $input) {
      success
    message
    }
  }
`;

export const createwarehouse = gql`
  mutation createwarehouse($input: WarehouseInput!) {
    createWarehouse(input: $input) {
      set
    }
  }
`;

export const updatewarehouse = gql`
  mutation updatewarehouse($input: UpdateWarehouseInput!) {
    updateWarehouse(input: $input) {
      Warehouse {
        id
        warehouseName
        category
        addressLine1
        addressLine2
        country
        State
        city
        zipCode
        supervisorName
        supervisorNumber
        warehouseContactNumber
        warehouseCapacity
        capacityUom
        brand {
          brandName
        }
        warehouseCost
        sellingPrice
        SKU
        HSNNumber
        UOM {
          uomName
        }
        reorderLevel
        Tax
        warehouseImage
        Description
      }
    }
  }
`;

export const updateproduct = gql`
  mutation updateproduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      Product {
        id
        productName
        category {
          categoryName
        }
        brand {
          brandName
        }
        productCost
        sellingPrice
        SKU
        HSNNumber
        UOM {
          uomName
        }
        reorderLevel
        location {
          warehouseName
        }
        Tax
        productImage
        description
      }
    }
  }
`;

export const deteteQuotation = gql`
  mutation deteteQuotation($id: String!) {
    deleteQuotation(id: $id) {
      set
    }
  }
`;

export const updateQuotationandproduct = gql`
  mutation update($input: UpdateTotalQuotaionInput!) {
    updateQuotationandproduct(input: $input) {
      success
      message
    }
  }
`;
